import React from 'react';
import { PriceAlert } from '../components/PriceAlert';
import { Hero } from '../components/Hero';
import { Testimonial } from '../components/Testimonial';
import { ProblemSolution } from '../components/ProblemSolution';
import { ValueStack } from '../components/ValueStack';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-883">
      <PriceAlert data-id="element-884" />
      <Hero data-id="element-885" />
      <Testimonial data-id="element-886" />
      <ProblemSolution data-id="element-887" />
      <ValueStack data-id="element-888" />
      <ModuleBreakdown data-id="element-889" />
      <Guarantee data-id="element-890" />
      <PricingSection data-id="element-891" />
      <Footer data-id="element-892" />
      <RecentPurchaseToast data-id="element-893" />
    </div>;
}